import {
  GET_ALL_TASKS_REQUEST,
  GET_ALL_TASKS_SUCCESS,
  GET_ALL_TASKS_FAILURE,
  SET_SELECTED_TASK_FOR_LAUNCH,
  GET_TASK_DETAILS_REQUEST,
  GET_TASK_DETAILS_SUCCESS,
  GET_TASK_DETAILS_FAILURE,
  CLEAR_SELECTED_TASK,
  CLEAR_ADMIN_TASKS_DATA,
} from "../actionTypes/tasks";
import { GET_TASK_PARAMETERS_SUCCESS } from "../actionTypes/parameter";
import { GET_CUSTOM_TASK_MANIFEST_SUCCESS } from "../actionTypes/task";
import {
  GET_TASK_PARAMETERS_REQUEST,
  GET_TASK_PARAMETERS_FAILURE,
} from "../actionTypes/parameter";
import { SET_PARAMETERS } from "../../task/actionTypes/task";

import { isJson } from "../../../utils/json";
import { preProcessParameters } from "../../../utils/blueprint";
import {
  CUSTOMER,
  COMPLIANCE,
  SECURITY_REMEDIATION,
  AUTHOR_MONTYCLOUD,
  SECURITY,
  TYPE_EXECUTE_DAY2_TASK,
  TYPE_EXECUTE_TASK,
  TASK_KEYS,
} from "../../../utils/app-constants.json";
import { sortArrayAlphabetically } from "../../../utils/array-methods";
import { getUpdatedParams } from "../utils";
import { getAllTasksApi, getTaskDetailsApi } from "../services/tasks";
import { faker } from "@faker-js/faker";
import { isFeatureEnabled, featuresList } from "../../../config/featureflags";
import { isArrayWithLength } from "../../../utils/array-methods";
import i18n from "../../../config/locale/i18n";
import { getTaskFilters } from "../../../utils/task";
import { v4 as uuidv4 } from "uuid";

export const setSelectedTaskToExecute = (task) => ({
  type: SET_SELECTED_TASK_FOR_LAUNCH,
  payload: task,
});

export const clearAdminTaskData = () => ({
  type: CLEAR_ADMIN_TASKS_DATA,
});

export const getTaskType = (task) => {
  let type,
    taskName,
    icon,
    hide,
    color,
    taskCategory = "";
  const name = task && (task.Name || task.name);
  const owner = task && (task.Owner || task.owner);
  switch (name) {
    case "start":
      type = "start-instance";
      taskName = "Start Instance";
      icon = "fa fa-play";
      color = "#2e9876";
      break;
    case "stop":
      type = "stop-instance";
      taskName = "Stop Instance";
      icon = "fa fa-stop";
      color = "#f55d5d";
      break;
    case "restart":
      type = "restart-instance";
      taskName = "Restart Instance";
      icon = "fa fa-repeat";
      color = "#ffc247";
      break;
    case "terminate":
      type = "terminate-instance";
      taskName = "Terminate Instance";
      icon = "fa fa-power-off";
      color = "#af1005";
      break;

    case TASK_KEYS.START_WORKSPACES:
      type = TASK_KEYS.START_WORKSPACES;
      taskName = "Start Workspaces";
      icon = "fa fa-play";
      color = "#2e9876";
      break;
    case TASK_KEYS.STOP_WORKSPACES:
      type = TASK_KEYS.STOP_WORKSPACES;
      taskName = "Stop Workspaces";
      icon = "fa fa-stop";
      color = "#f55d5d";
      break;
    case TASK_KEYS.REBOOT_WORKSPACES:
      type = TASK_KEYS.REBOOT_WORKSPACES;
      taskName = "Reboot Workspaces";
      icon = "fa fa-repeat";
      color = "#ffc247";
      break;
    case TASK_KEYS.TERMINATE_WORKSPACES:
      type = TASK_KEYS.TERMINATE_WORKSPACES;
      taskName = "Terminate Workspaces";
      icon = "fa fa-power-off";
      color = "#af1005";
      break;
    case TASK_KEYS.START_NOTEBOOK_INSTANCES:
      type = TASK_KEYS.START_NOTEBOOK_INSTANCES;
      taskName = "Start Notebook Instances";
      icon = "fa fa-play";
      color = "#2e9876";
      break;
    case TASK_KEYS.STOP_NOTEBOOK_INSTANCES:
      type = TASK_KEYS.STOP_NOTEBOOK_INSTANCES;
      taskName = "Stop Notebook Instances";
      icon = "fa fa-stop";
      color = "#f55d5d";
      break;
    case "createSnapshot":
      type = "create-snapshot";
      taskName = "Create Snapshot";
      icon = "fa fa-camera";
      color = "#f69720";
      break;
    case "configureCloudWatchAgent":
      type = "configure-cloud-watch";
      taskName = i18n.t("tasks:installCloudwatch");
      icon = "fa fa-server";
      color = "#d21373";
      break;
    case "createImage":
      type = "create-image";
      taskName = "Create Image";
      icon = "fa fa-camera";
      color = "#f69720";
      break;
    case "copyImage":
      type = "copy-image";
      taskName = "Copy Image";
      icon = "fa fa-copy";
      color = "#f69720";
      break;
    case "shareImage":
      type = "share-image";
      taskName = "Share Image";
      icon = "fa fa-share-alt";
      color = "#f69720";
      break;
    case "scanPatch":
      type = "scan";
      taskName = "Scan";
      icon = "fa fa-search";
      color = "#004575";
      break;
    case "installPatch":
      type = "patch";
      taskName = "Patch";
      icon = "fa fa-server";
      color = "#004575";
      break;
    case "executeDss":
      type = "desired-state";
      taskName = "Desired Server State";
      icon = "fa fa-server";
      color = "#004575";
      break;
    case TASK_KEYS.RESIZE_INSTANCE:
      type = TASK_KEYS.RESIZE_INSTANCE;
      taskName = "Resize Instance";
      icon = "fa fa-pencil";
      break;
    case TASK_KEYS.DELETE_SNAPSHOT:
      type = TASK_KEYS.DELETE_SNAPSHOT;
      taskName = "Delete Snapshot";
      icon = "fa fa-trash";
      break;
    case "modifyEBSVolumeType":
      type = "modify-volume-type";
      taskName = i18n.t("volumes:modifyEBSVolumeType");
      icon = "fa fa-pencil";
      break;
    case "deleteEBSVolumes":
      type = "delete-volume";
      taskName = i18n.t("volumes:deleteVolume");
      icon = "fa fa-trash";
      break;
    case "Desired Account State":
      type = "desired-account-state";
      taskName = "Desired Account State";
      icon = "fa fa-server";
      hide = true;
      break;
    case "Desired Region State":
      type = "desired-region-state";
      taskName = "Desired Region State";
      icon = "fa fa-server";
      hide = true;
      break;
    default:
      const isMCOwnedTask = owner && owner.toLowerCase() === AUTHOR_MONTYCLOUD;
      if (isMCOwnedTask) {
        taskCategory = task.Category;
        type = TYPE_EXECUTE_DAY2_TASK;
        taskName = name;
        icon = "fa fa-tasks";
      } else {
        type = TYPE_EXECUTE_TASK;
        taskName = name;
        icon = "fa fa-tasks";
      }
      break;
  }
  return { type, taskName, icon, hide, color, taskCategory };
};

export const preProcessTask = (task) => {
  let content;
  if (task.TaskType === "PythonScript") {
    content = task.Content;
  } else {
    content =
      task.Content &&
      (isJson(task.Content) ? JSON.parse(task.Content) : task.Content);
  }
  const hasParameters =
    task &&
    task.Parameters &&
    task.Parameters.parameterGroups &&
    isArrayWithLength(task.Parameters.parameterGroups);
  const metadata = task && task.Metadata;
  const isMCOwnedTask =
    task.Owner && task.Owner.toLowerCase() === AUTHOR_MONTYCLOUD;

  const { taskName, type, hide, taskCategory } = getTaskType(task);
  return {
    id: task.ID,
    name: (metadata && metadata.Label) || taskName,
    owner: task.Owner,
    description: task.Description,
    type: task.TaskType,
    isEnabled: task.IsEnable,
    taskType: task.Type || type,
    hideActions: isMCOwnedTask,
    parameters: task.Parameters,
    permissions: task.Permissions,
    isRecommendedTask: task.IsRecommendedTask,
    botType: task.BotType,
    content: content,
    roleName: task.Role,
    roleUrl: task.PermissionPath,
    hide: hide || task.Hide,
    isJsonTypeContent: isJson(task.Content),
    category: task.Category,
    scriptHandler: metadata && metadata.Handler,
    remediationOnly: metadata && metadata.RemediationOnly,
    skipPermissions: metadata && metadata.SkipPermissions,
    skipParameters: metadata && metadata.SkipParameters,
    globalTask: metadata && metadata.GlobalTask,
    hasParameters,
    taskCategory,
  };
};

const tasksToBeAdded = [
  {
    ID: uuidv4(),
    Name: "Deploy Blueprint",
    Type: "launch-blueprint",
    TaskType: "DAY2",
    Description: "Deploy Blueprint",
    Owner: "MontyCloud",
    IsEnable: true,
  },
  {
    ID: uuidv4(),
    Name: "Data Refresh",
    Type: "data-refresh",
    TaskType: "DAY2",
    Description: "Data Refresh",
    Owner: "MontyCloud",
    Hide: !isFeatureEnabled(featuresList.DATA_REFRESH),
    IsEnable: true,
  },
];

export const preProcessTasks = (tasks) => {
  let day2Tasks = [];
  let botTasks = [];
  let customerTasks = [];
  let recommendedTasks = [];
  let otherTasks = [];

  isArrayWithLength(tasks) &&
    tasks.forEach((task) => {
      if (task.TaskType === "DAY2") {
        day2Tasks.push(task);
      } else if (
        task.Owner.toLowerCase() === AUTHOR_MONTYCLOUD &&
        [COMPLIANCE, SECURITY, SECURITY_REMEDIATION].includes(task.Category) &&
        !task.IsRecommendedTask
      ) {
        botTasks.push(task);
      } else if (task.Owner === CUSTOMER) {
        customerTasks.push(task);
      } else if (task.IsRecommendedTask) {
        recommendedTasks.push(task);
      } else {
        otherTasks.push(task);
      }
    });

  const allTasks = day2Tasks.concat(
    tasksToBeAdded,
    customerTasks,
    recommendedTasks,
    sortArrayAlphabetically(botTasks, "Name"),
    otherTasks
  );
  const preProcessedTaskList = allTasks.map((task) => {
    return preProcessTask(task);
  });
  return preProcessedTaskList;
};

const getAllTasksRequest = () => ({
  type: GET_ALL_TASKS_REQUEST,
});

const getAllTasksSuccess = (payload) => ({
  type: GET_ALL_TASKS_SUCCESS,
  payload,
});

const getAllTasksError = (payload) => ({
  type: GET_ALL_TASKS_FAILURE,
  payload,
});

export const getAllTasks = () => (dispatch) => {
  dispatch(getAllTasksRequest());
  const params = getTaskFilters();
  getAllTasksApi(params)
    .then((result) => {
      const tasks = preProcessTasks(result);
      dispatch(getAllTasksSuccess(tasks));
    })
    .catch(() => {
      dispatch(getAllTasksError());
    });
};

export const getTaskDetailsRequest = () => ({
  type: GET_TASK_DETAILS_REQUEST,
});

export const getTaskManifestSuccess =
  (payload, configParameters, outputParameters, isExecutingTask) =>
  (dispatch, getState) => {
    const updatedPayload = payload;
    const parameters =
      isArrayWithLength(updatedPayload) &&
      updatedPayload
        .map((group) => {
          return (
            group.parameters && group.parameters.map((parameter) => parameter)
          );
        })
        .flat();
    const processedParams = preProcessParameters(
      parameters,
      configParameters,
      outputParameters
    );
    if (isExecutingTask) {
      const { task, botInsight } = getState();
      const updatedParams = getUpdatedParams(
        processedParams,
        task && task,
        botInsight && botInsight.selectedInsight
      );
      dispatch({
        type: GET_TASK_PARAMETERS_SUCCESS,
        payload: {
          groups: updatedPayload,
          parameters: updatedParams,
        },
      });
    } else {
      dispatch({
        type: GET_CUSTOM_TASK_MANIFEST_SUCCESS,
        payload: updatedPayload,
      });
      dispatch({
        type: SET_PARAMETERS,
        payload: processedParams,
      });
    }
  };

export const getTaskDetailsSuccess =
  (payload, isExecutingTask, isDAY2Task) => (dispatch, getState) => {
    if (!isDAY2Task) {
      const { application } = getState();
      const configParameters = application && application.parameters;
      const outputParameters = application && application.output;
      const parameterGroups =
        payload.parameters && payload.parameters.parameterGroups;
      if (payload) {
        dispatch(
          getTaskManifestSuccess(
            parameterGroups,
            configParameters,
            outputParameters,
            isExecutingTask
          )
        );
      }
    }
    dispatch({
      type: GET_TASK_DETAILS_SUCCESS,
      payload,
    });
  };

const getTaskDetailsError = (payload) => ({
  type: GET_TASK_DETAILS_FAILURE,
  payload,
});

export const getTaskDetails = (id, isExecutingTask) => (dispatch) => {
  isExecutingTask
    ? dispatch({
        type: GET_TASK_PARAMETERS_REQUEST,
      })
    : dispatch(getTaskDetailsRequest());
  getTaskDetailsApi(id)
    .then((result) => {
      const data = { ...result, ID: id };
      const task = preProcessTask(data);
      dispatch(getTaskDetailsSuccess(task, isExecutingTask));
    })
    .catch((error) => {
      isExecutingTask
        ? dispatch({
            type: GET_TASK_PARAMETERS_FAILURE,
            payload: error,
          })
        : dispatch(getTaskDetailsError(error));
    });
};

export const clearSelectedTask = (task) => ({
  type: CLEAR_SELECTED_TASK,
});
